import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import themeConfig from '../config/themeConfig';

const { FiZap } = FiIcons;

const LogoPlaceholder = ({ className = "h-10 w-auto", showText = true }) => {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Logo Icon Placeholder */}
      <div className="bg-primary-600 p-1.5 md:p-2 rounded-lg">
        <SafeIcon icon={FiZap} className="h-4 w-4 md:h-6 md:w-6 text-white" />
      </div>
      
      {/* Logo Text */}
      {showText && (
        <span className="text-lg md:text-2xl font-bold text-gray-900 hidden sm:block">
          {themeConfig.logo.placeholder.text}
          <span className="text-primary-600">
            {themeConfig.logo.placeholder.accentText}
          </span>
        </span>
      )}
    </div>
  );
};

export default LogoPlaceholder;